import { ILoginPayload } from '../model/login';
import { useLoginService } from '../service/login';

export const useLoginApplication = () => {
  const { login, ...restLoginService } = useLoginService();

  async function loginApp(data: ILoginPayload) {
    return login(data);
  }

  return {
    loginApp,
    ...restLoginService,
  };
};

export default useLoginApplication;
